<template>
  <Flicking
    :options="{
      align: 'prev',
      bound: false,
      panelsPerView: 2,
      circular: false,
      resizeOnContentsReady: true,
      preventClickOnDrag: true
    }"
    :plugins="plugins"
  >
    <template>
      <div
        v-for="item in items"
        :key="item.id"
        class="card-panel mx-3 cursor-pointer"
        :class="{'active': activeItemValue == item.id}"
        @click="handleClick(item.id)"
      >
        <img
          class="h-100 w-100 object-cover"
          :src="item.picture"
          :alt="item.id"
        />
      </div>
    </template>

    <span slot="viewport" class="flicking-arrow-prev is-thin" />
    <span slot="viewport" class="flicking-arrow-next is-thin" />
  </Flicking>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import { Arrow } from "@egjs/flicking-plugins";

const plugins = [new Arrow()];

export default defineComponent({
    name: "FlickerCarousel",
    data() {
        return {
            plugins
        };
    },
    props: {
        items: {
            type: Array,
            required: true
        },
        activeItemValue: {
            type: Array|String|Number|Object,
            required: true
        },
        handleClick: {
            type: Function,
            required: true
        }
    },
});
</script>

<style scoped>
.flicking-viewport {
    width: 100%;
    height: 80px;
    overflow: hidden;
    position: relative;
}

.flicking-arrow-prev::before, .flicking-arrow-prev::after, .flicking-arrow-next::before, .flicking-arrow-next::after {
    background-color: #111;
}

.card-panel {
    border: 1px solid transparent;
    border-radius: 7px;
}

.card-panel:hover {
    border-radius: 7px;
}

.card-panel:hover {
    border: 1px solid #aeaeae;
}

.card-panel.active {
    border: 1px solid var(--main-color);
}
</style>



// WEBPACK FOOTER //
// src/components/atoms/FlickerCarousel.vue